import React, { Component } from "react";
import CustomModal from "../../shared/CustomModal";
import { salesRepMessages } from "../../helpers/messages";
import { updateReviewPlanStatusService } from '../../services/java/java-services';

export default class PreOpPlanStatusConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      error:''
    };
  }

  /**
   * @description Function to close modal when clicked on close button
   * @memberof PreOpPlanStatusConfirm
   */

  closeModal = () => {
    this.setState({ isLoading: false, error :'' });
    this.props.closeModal();
  };

  handleConfirm = () => {
    this.setState({ isLoading: true, error :'' });
    const params = {
      "caseNumbers": this.props.selectedPreOpPlans,
		  "status": '2',
    }
    updateReviewPlanStatusService(params, (err, response) => {
      if (err) {
          this.setState({ error: err.message, isLoading: false });
      } else {
               this.closeModal() 
          }
  });
  }
  
  render() {
    const { isLoading, error } = this.state;
    const { showModal, selectedPreOpPlans } = this.props;

    return (
      <CustomModal
        show={showModal}
        dialogClassName="overlapping-points-modal"
        isComponent={true}
        title="PreOp Plan Status Update"
        rejectAction={this.closeModal}
        closeAction={this.closeModal}
        hideClose={true}
      >
        <div className="row">
          <div className="col">
            <div className="body body-section">
              <p>{selectedPreOpPlans.length === 1 ? salesRepMessages.preopPlanSingleUpdate : salesRepMessages.preopPlanMultipleUpdate}</p>
              <p>{salesRepMessages.preopPlanUpdateConfirm} </p>
                 {error && (<p className="p-2 text-danger">{error}</p>)}
              <div className="d-flex justify-content-end gap-1 text-center mt-3">
              <button
                  className="custom-action-btn btn btn-primary"
                  id="update-status"
                  data-testid="update-status"
                  onClick={this.handleConfirm}
                >
                  {isLoading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Yes"
                  )}
                </button>
                <button className="custom-action-btn btn btn-light" onClick={this.closeModal}>
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    );
  }
}
